// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { TreeSelectTokens } from './type';

const treeSelectTokens: TreeSelectTokens = {
  treeSelectWidth: 'Size-120',
  treeSelectFontSize: '14/regular',
  treeSelectFontColor: 'Neutral-text-5',
  treeSelectBorderRadius: 'Radius-4',
  treeSelectBorderColor: 'Neutral-border-2',
  treeSelectPaddingX: 'Padding-8',
  treeSelectPaddingY: 'Padding-2',
  treeSelectIconSize: 'Size-7',
  treeSelectIconColor: 'Neutral-text-4',
  treeSelectSmallFontSize: '12/regular',
  treeSelectSmallPaddingX: 'Padding-8',
  treeSelectSmallPaddingY: 'Padding-1',
  treeSelectSmallOptionInnerPaddingX: 'Padding-8',
  treeSelectSmallOptionInnerPaddingY: 'Padding-2',
  treeSelectLargeFontSize: '16/regular',
  treeSelectLargePaddingX: 'Padding-12',
  treeSelectLargePaddingY: 'Padding-3',
  treeSelectLargeOptionInnerPaddingX: 'Padding-12',
  treeSelectLargeOptionInnerPaddingY: 'Padding-8',
  treeSelectLargePlaceholderMarginY: 'Padding-4',
  treeSelectInnerPaddingX: 'Padding-8',
  treeSelectInnerPaddingY: 'Padding-5',
  treeSelectPlaceholderColor: 'Neutral-text-2',
  treeSelectPlaceholderMarginY: 'Padding-2',
  treeSelectBackgroundColor: 'Neutral-fill-1',
  treeSelectClearColor: 'Neutral-text-3',
  treeSelectClearPadding: 'Padding-8',
  treeSelectHoverBorderColor: 'Brand-6',
  treeSelectHoverClearColor: 'Neutral-text-4',
  treeSelectFocusBorderColor: 'Brand-7',
  treeSelectFocusShadow: 'Brand-2',
  treeSelectDisabledFontColor: 'Neutral-text-2',
  treeSelectDisabledPlaceholderColor: 'Neutral-text-2',
  treeSelectDisabledBorderColor: 'Neutral-border-2',
  treeSelectDisabledBackgroundColor: 'Neutral-fill-2',
  treeSelectResultTextBorderRadius: 'Radius-4',
  treeSelectResultTextPaddingX: 'Padding-4',
  treeSelectResultTextSmallPaddingX: 'Padding-4',
  treeSelectResultTextLargePaddingX: 'Padding-10',
  treeSelectResultTextActiveBackgroundColor: 'Brand-1',
  treeSelectErrorBorderColor: 'Danger-6',
  treeSelectErrorFocusShadow: 'Danger-1',
  treeSelectPanelColor: 'Neutral-text-5',
  treeSelectPanelBackgroundColor: 'Neutral-fill-1',
  treeSelectPanelShadow: 'Shadow-2',
  treeSelectPanelRadius: 'Radius-4',
  treeSelectPanelBorder: 'Neutral-border-1',
  treeSelectOptionHeight: 'Size-16',
  treeSelectOptionPaddingX: 'Padding-4',
  treeSelectOptionPaddingY: 'Padding-1',
  treeSelectOptionActiveColor: 'Brand-6',
  treeSelectOptionActiveBackgroundColor: 'Brand-1',
  treeSelectOptionInnerPaddingX: 'Padding-8',
  treeSelectOptionInnerPaddingY: 'Padding-5',
  treeSelectOptionInnerPaddingRight: 'Size-15',
  treeSelectOptionInnerBorderRadius: 'Radius-2',
  treeSelectOptionHoverBackgroundColor: 'Neutral-fill-2',
  treeSelectOptionDisabledColor: 'Neutral-text-2',
  treeSelectOptionDisabledBackgroundColor: 'Neutral-fill-1',
  treeSelectMorePaddingX: 'Padding-16',
  treeSelectMorePaddingY: 'Padding-14',
  treeSelectHeaderPadding: 'Padding-8',
  treeSelectHeaderBorderColor: 'Neutral-border-1',
  treeSelectGroupTitleFontColor: 'Neutral-text-3',
  treeSelectGroupTitleFontSize: '12/regular',
  treeSelectGroupTitlePaddingX: 'Padding-12',
  treeSelectGroupTitlePaddingY: 'Padding-6',
  treeSelectColumnPadding: 'Padding-8',
  treeSelectColumnOptionMargin: 'Margin-8',
};

export default treeSelectTokens;
